export const translations = {
  id: {
    nav: {
      home: 'Beranda',
      destinations: 'Destinasi',
      privateTrips: 'Perjalanan Privat',
      journal: 'Jurnal',
      planMyTrip: 'Rencanakan Perjalanan',
      contact: 'Hubungi Kami',
    },
    whatsappCta: 'Konsultasi WhatsApp',
    hero: {
      kicker: 'Yoeli Chan Journey · Perjalanan Privat Premium yang Terjangkau',
      line1: 'Jelajahi Asia,',
      line2: 'Dengan Caramu.',
      sub: 'Perjalanan privat yang dirancang dengan cermat sesuai kenyamanan, preferensi, dan budget Anda.',
      ctaPrimary: 'Jelajahi Destinasi',
      ctaSecondary: 'Rencanakan Perjalanan',
      scroll: 'Gulir untuk menjelajah',
    },
    home: {
      popularKicker: 'Destinasi Populer',
      popularTitle: 'Ke Mana Perjalanan Anda Berikutnya?',
      popularSub: 'Delapan negara pilihan di Asia — masing-masing dengan karakter, rasa, dan cerita yang menunggu untuk Anda temukan secara privat.',
      explore: 'Jelajahi',
      whyKicker: 'Mengapa Kami',
      whyTitle: 'Perjalanan yang Dirancang untuk Anda',
      whySub: 'Kami percaya perjalanan terbaik bukan yang paling mahal — melainkan yang paling sesuai dengan Anda.',
      why: [
        { title: 'Itinerari Personal', desc: 'Setiap perjalanan disusun dari nol berdasarkan minat, ritme, dan gaya traveling Anda — bukan paket massal.' },
        { title: 'Transportasi Privat', desc: 'Kendaraan pribadi dengan sopir berpengalaman, tanpa menunggu rombongan atau terburu-buru.' },
        { title: 'Perjalanan Nyaman', desc: 'Hotel pilihan, jadwal fleksibel, dan waktu istirahat yang cukup untuk keluarga, pasangan, dan sahabat.' },
        { title: 'Harga Kompetitif', desc: 'Pengalaman premium yang tetap terjangkau — proposal transparan sesuai budget yang Anda tentukan.' },
      ],
      howKicker: 'Cara Kerja',
      howTitle: 'Empat Langkah Menuju Perjalanan Impian',
      steps: [
        { title: 'Pilih Destinasi Anda', desc: 'Jelajahi katalog destinasi kami dan temukan negara yang memikat hati Anda.' },
        { title: 'Ceritakan Preferensi Anda', desc: 'Isi formulir singkat atau chat WhatsApp — tanggal, budget, gaya perjalanan.' },
        { title: 'Terima Proposal Perjalanan', desc: 'Kami susun itinerari personal lengkap dengan rekomendasi terbaik untuk Anda.' },
        { title: 'Nikmati Perjalanan Anda', desc: 'Berangkat dengan tenang — semua detail sudah kami urus. Anda tinggal menikmati.' },
      ],
      ctaTitle: 'Perjalanan Impian Anda Dimulai di Sini.',
      ctaSub: 'Ceritakan perjalanan yang Anda bayangkan — kami yang merancang sisanya.',
      ctaButton: 'Rencanakan Perjalanan',
    },
    seasonal: {
      kicker: 'Paket Musiman',
      title: 'Momen Terbaik di Waktu Terbaik',
      sub: 'Perjalanan yang dirancang mengikuti musim terindah di setiap destinasi — kuota terbatas di setiap musimnya.',
      cta: 'Ajukan Paket Ini',
    },
    journal: {
      kicker: 'Jurnal Perjalanan',
      title: 'Cerita & Panduan dari Asia',
      sub: 'Tips, panduan, dan inspirasi perjalanan privat dari tim Yoeli Chan Journey.',
      readMore: 'Baca Selengkapnya',
      back: 'Semua Artikel',
      minRead: 'menit baca',
      ctaTitle: 'Terinspirasi untuk Berangkat?',
      ctaSub: 'Wujudkan cerita ini menjadi perjalanan Anda sendiri — ceritakan rencana Anda, kami yang merancang sisanya.',
      ctaButton: 'Rencanakan Perjalanan Anda',
    },
    destinationsPage: {
      kicker: 'Katalog Destinasi',
      title: 'Delapan Negara, Satu Cara Anda',
      sub: 'Setiap destinasi dapat disesuaikan sepenuhnya — durasi, ritme, dan pengalaman. Klik untuk melihat gambaran perjalanan.',
      overview: 'Gambaran Destinasi',
      attractions: 'Atraksi Populer',
      durationLabel: 'Durasi Perjalanan yang Disarankan',
      experiences: 'Pengalaman yang Direkomendasikan',
      itinerary: 'Contoh Itinerari',
      day: 'Hari',
      customize: 'Sesuaikan Perjalanan Ini',
      back: 'Semua Destinasi',
      notFound: 'Destinasi tidak ditemukan.',
    },
    trips: {
      kicker: 'Perjalanan Privat',
      title: 'Paket Contoh yang Sepenuhnya Fleksibel',
      sub: 'Semua paket di bawah ini hanyalah titik awal — setiap detail dapat disesuaikan dengan preferensi dan budget Anda.',
      duration: 'Durasi',
      groupSize: 'Ukuran Grup',
      itinerary: 'Ringkasan Itinerari',
      attractions: 'Atraksi Utama',
      included: 'Termasuk',
      excluded: 'Tidak Termasuk',
      request: 'Ajukan Perjalanan Ini',
      note: 'Tidak ada pemesanan instan — setiap permintaan akan kami balas secara personal melalui WhatsApp dengan proposal yang disesuaikan.',
    },
    form: {
      kicker: 'Rencanakan Perjalanan',
      title: 'Ceritakan Perjalanan Impian Anda',
      sub: 'Isi formulir singkat ini — pesan Anda akan terkirim langsung ke WhatsApp kami dan kami akan membalas dengan proposal personal. Tanpa akun, tanpa pembayaran di muka.',
      fullName: 'Nama Lengkap',
      fullNamePh: 'Nama Anda',
      whatsapp: 'Nomor WhatsApp',
      whatsappPh: 'cth: 0812 3456 7890',
      destination: 'Destinasi (boleh pilih lebih dari satu)',
      departure: 'Tanggal Berangkat',
      return: 'Tanggal Kembali',
      travelers: 'Jumlah Wisatawan',
      travelersOptions: ['1–2 orang', '3–4 orang', '5–8 orang', '9 orang atau lebih'],
      hotel: 'Kategori Hotel Pilihan',
      hotelOptions: ['Bintang 3 — Nyaman', 'Bintang 4 — Premium', 'Bintang 5 — Mewah', 'Fleksibel / Rekomendasi kami'],
      budget: 'Estimasi Budget per Orang',
      budgetOptions: ['Di bawah Rp 5 juta', 'Rp 5–10 juta', 'Rp 10–20 juta', 'Di atas Rp 20 juta', 'Budget fleksibel'],
      preferences: 'Preferensi Perjalanan',
      preferencesOptions: ['Budaya & Sejarah', 'Kuliner', 'Belanja', 'Alam & Petualangan', 'Relaksasi & Spa', 'Ramah Keluarga', 'Fotografi', 'Halal Friendly'],
      additional: 'Permintaan Tambahan',
      additionalPh: 'Ceritakan hal lain yang penting bagi Anda — perayaan khusus, kebutuhan aksesibilitas, makanan, dll.',
      submit: 'Kirim Permintaan Perjalanan Saya',
      successTitle: 'Membuka WhatsApp…',
      successDesc: 'Pesan perjalanan Anda sudah disiapkan. Periksa kembali dan tekan kirim di WhatsApp.',
      required: 'Mohon lengkapi nama, nomor WhatsApp, dan minimal satu destinasi.',
      prefillPackage: 'Paket yang diminati',
    },
    contact: {
      kicker: 'Hubungi Kami',
      title: 'Mari Bicara Tentang Perjalanan Anda',
      sub: 'Cara tercepat adalah WhatsApp — namun kami juga senang mendengar dari Anda melalui email atau Instagram.',
      whatsappLabel: 'WhatsApp',
      emailLabel: 'Email',
      instagramLabel: 'Instagram',
      officeLabel: 'Lokasi Kantor',
      formTitle: 'Kirim Pesan',
      name: 'Nama',
      namePh: 'Nama Anda',
      message: 'Pesan',
      messagePh: 'Halo, saya ingin bertanya tentang…',
      send: 'Kirim via WhatsApp',
      hours: 'Jam Layanan',
      hoursValue: 'Senin–Sabtu, 09.00–18.00 WIB',
    },
    footer: {
      desc: 'Biro perjalanan privat butik yang menghadirkan perjalanan personal di seluruh Asia — nyaman, fleksibel, dan terjangkau untuk keluarga, pasangan, sahabat, dan grup kecil.',
      explore: 'Jelajahi',
      contactUs: 'Kontak',
      rights: 'Seluruh hak cipta dilindungi.',
    },
    whatsappDefault: 'Halo YOELI CHAN JOURNEY! Saya ingin berkonsultasi tentang perjalanan privat ke Asia.',
  },
  en: {
    nav: {
      home: 'Home',
      destinations: 'Destinations',
      privateTrips: 'Private Trips',
      journal: 'Journal',
      planMyTrip: 'Plan My Trip',
      contact: 'Contact Us',
    },
    whatsappCta: 'WhatsApp Consultation',
    hero: {
      kicker: 'Yoeli Chan Journey · Affordable Premium Private Travel',
      line1: 'Explore Asia,',
      line2: 'Your Way.',
      sub: 'Private journeys thoughtfully designed around your comfort, preferences, and budget.',
      ctaPrimary: 'Explore Destinations',
      ctaSecondary: 'Plan My Trip',
      scroll: 'Scroll to explore',
    },
    home: {
      popularKicker: 'Popular Destinations',
      popularTitle: 'Where Will Your Next Journey Take You?',
      popularSub: 'Eight hand-picked countries across Asia — each with its own character, flavour, and story waiting for you to discover privately.',
      explore: 'Explore',
      whyKicker: 'Why Choose Us',
      whyTitle: 'Travel Designed Around You',
      whySub: 'We believe the best journeys are not the most expensive ones — but the ones that fit you perfectly.',
      why: [
        { title: 'Personalized Itineraries', desc: 'Every journey is built from scratch around your interests, pace, and travel style — never a mass-market package.' },
        { title: 'Private Transportation', desc: 'Your own vehicle with an experienced driver — no waiting for groups, no rushing.' },
        { title: 'Comfortable Travel', desc: 'Hand-picked hotels, flexible schedules, and enough rest time for families, couples, and friends.' },
        { title: 'Competitive Pricing', desc: 'Premium experiences that stay affordable — transparent proposals matched to the budget you set.' },
      ],
      howKicker: 'How It Works',
      howTitle: 'Four Steps to Your Dream Journey',
      steps: [
        { title: 'Choose Your Destination', desc: 'Browse our destination catalog and find the country that captures your heart.' },
        { title: 'Tell Us Your Preferences', desc: 'Fill in a short form or chat on WhatsApp — dates, budget, travel style.' },
        { title: 'Receive Your Custom Travel Proposal', desc: 'We craft a personal itinerary complete with our best recommendations for you.' },
        { title: 'Enjoy Your Journey', desc: 'Depart with peace of mind — every detail is handled. You simply enjoy.' },
      ],
      ctaTitle: 'Your Dream Journey Starts Here.',
      ctaSub: 'Tell us the journey you imagine — we will design everything else.',
      ctaButton: 'Plan My Trip',
    },
    seasonal: {
      kicker: 'Seasonal Packages',
      title: 'The Best Moments at the Best Times',
      sub: 'Journeys designed around each destination\'s most beautiful season — limited slots every season.',
      cta: 'Request This Package',
    },
    journal: {
      kicker: 'Travel Journal',
      title: 'Stories & Guides from Asia',
      sub: 'Tips, guides, and private travel inspiration from the Yoeli Chan Journey team.',
      readMore: 'Read More',
      back: 'All Articles',
      minRead: 'min read',
      ctaTitle: 'Inspired to Go?',
      ctaSub: 'Turn this story into your own journey — tell us your plans, we will design everything else.',
      ctaButton: 'Plan Your Trip',
    },
    destinationsPage: {
      kicker: 'Destination Catalog',
      title: 'Eight Countries, One Way — Yours',
      sub: 'Every destination can be fully tailored — duration, pace, and experiences. Click to preview the journey.',
      overview: 'Destination Overview',
      attractions: 'Popular Attractions',
      durationLabel: 'Recommended Travel Duration',
      experiences: 'Suggested Travel Experiences',
      itinerary: 'Example Itinerary',
      day: 'Day',
      customize: 'Customize This Trip',
      back: 'All Destinations',
      notFound: 'Destination not found.',
    },
    trips: {
      kicker: 'Private Trips',
      title: 'Example Packages, Fully Flexible',
      sub: 'Every package below is only a starting point — each detail can be tailored to your preferences and budget.',
      duration: 'Duration',
      groupSize: 'Group Size',
      itinerary: 'Itinerary Snapshot',
      attractions: 'Main Attractions',
      included: 'Included Services',
      excluded: 'Excluded Services',
      request: 'Request This Trip',
      note: 'No instant booking — every request is answered personally via WhatsApp with a tailored proposal.',
    },
    form: {
      kicker: 'Plan My Trip',
      title: 'Tell Us About Your Dream Journey',
      sub: 'Fill in this short form — your message goes straight to our WhatsApp and we will reply with a personal proposal. No account, no upfront payment.',
      fullName: 'Full Name',
      fullNamePh: 'Your name',
      whatsapp: 'WhatsApp Number',
      whatsappPh: 'e.g. 0812 3456 7890',
      destination: 'Destination (you may select more than one)',
      departure: 'Departure Date',
      return: 'Return Date',
      travelers: 'Number of Travelers',
      travelersOptions: ['1–2 people', '3–4 people', '5–8 people', '9 people or more'],
      hotel: 'Preferred Hotel Category',
      hotelOptions: ['3-Star — Comfortable', '4-Star — Premium', '5-Star — Luxury', 'Flexible / Our recommendation'],
      budget: 'Estimated Budget Per Person',
      budgetOptions: ['Below IDR 5 million', 'IDR 5–10 million', 'IDR 10–20 million', 'Above IDR 20 million', 'Flexible budget'],
      preferences: 'Travel Preferences',
      preferencesOptions: ['Culture & History', 'Culinary', 'Shopping', 'Nature & Adventure', 'Relaxation & Spa', 'Family Friendly', 'Photography', 'Halal Friendly'],
      additional: 'Additional Requests',
      additionalPh: 'Tell us anything else that matters — special occasions, accessibility needs, dietary requirements, etc.',
      submit: 'Send My Trip Request',
      successTitle: 'Opening WhatsApp…',
      successDesc: 'Your trip message is ready. Review it and press send in WhatsApp.',
      required: 'Please complete your name, WhatsApp number, and at least one destination.',
      prefillPackage: 'Package of interest',
    },
    contact: {
      kicker: 'Contact Us',
      title: "Let's Talk About Your Journey",
      sub: 'WhatsApp is the fastest way — but we are also happy to hear from you by email or Instagram.',
      whatsappLabel: 'WhatsApp',
      emailLabel: 'Email',
      instagramLabel: 'Instagram',
      officeLabel: 'Office Location',
      formTitle: 'Send a Message',
      name: 'Name',
      namePh: 'Your name',
      message: 'Message',
      messagePh: 'Hello, I would like to ask about…',
      send: 'Send via WhatsApp',
      hours: 'Service Hours',
      hoursValue: 'Monday–Saturday, 09:00–18:00 (GMT+7)',
    },
    footer: {
      desc: 'A boutique private travel agency crafting personal journeys across Asia — comfortable, flexible, and affordable for families, couples, friends, and small groups.',
      explore: 'Explore',
      contactUs: 'Contact',
      rights: 'All rights reserved.',
    },
    whatsappDefault: 'Hello YOELI CHAN JOURNEY! I would like to consult about a private trip to Asia.',
  },
};
